import _ from 'lodash';
export var getChannelId = function (state) { return _.get(state, 'channelInfo.info.id'); };
export var getCurrentChannelId = function (state) {
    return state.currentChannelId.currentChannelId;
};
